import axios from "axios";
import { base_url } from "../context/Authcontext";

const api = axios.create({
  baseURL: base_url,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.data?.logout === true
    ) {
      localStorage.removeItem("admin");
      localStorage.removeItem("role");
      window.location.replace("/admin/login");
    }

    return Promise.reject(error);
  }
);


export default api;
